import React from 'react';
import { dictionaryFieldTypes } from '@/constants/fields';
import InEditCell from '@/components/table/InEditCell';
import { cohortEqualsOperators, cohortExistOperators } from '../constants';
import { canEditCohort } from '../../helper';
import { newCohortFilterField } from '../state/state';
import { findQueryFilter } from '../../state/shared';

const QueryFilterContainer = ({
  exists,
  canRead,
  children,
  colSpan,
  width,
}) => (
  <InEditCell
    exists={exists}
    canRead={canRead}
    colSpan={colSpan}
    width={width}
  >
    {children}
  </InEditCell>
);

const filterPermissions = (role, exists = false, canEdit = false, isSystem = false) => ({
  exists,
  canEdit: exists ? canEdit : false,
  canRead: exists ? (role.permissions.cohorts.read || (isSystem && role.permissions.requests.review)) : false,
});

const withoutItem = (role) => (
  {
    ...filterPermissions(role),
    operator: cohortEqualsOperators.EQUALS,
    type: dictionaryFieldTypes.TEXT,
    saveErrors: [],
  }
);

const withItem = (dataset, dictionaryCode, item, role, cohort, filterBeforeEdit) => {
  const dictionary = dataset.dictionaries.find((r) => (r.code === dictionaryCode));
  const field = item.field
      || newCohortFilterField({
        type: dictionaryFieldTypes.TEXT, name: null, constraints: null, cohort_filter: true,
      });

  return (
    {
      ...filterPermissions(role, true, canEditCohort(cohort, role), cohort.system),
      isEditing: cohort.isEditing,
      saveErrors: cohort.saveErrors,
      operator: item.operator,
      values: item.values,
      join: item.join,
      fieldName: field.name,
      fieldLabel: field.label,
      fieldConstraints: field.constraints,
      fieldCohortFilter: field.cohort_filter,
      type: field.type,
      dictionary,
      dictionaries: dataset.dictionaries,
      hasValues: !Object.values(cohortExistOperators).includes(item.operator),
      fieldBeforeEdit: filterBeforeEdit?.field,
    }
  );
};

export const mapStateToProps = ({
  cohorts: {
    cohorts,
  },
  auth: {
    role,
  },
}, ownProps) => {
  const { cohort, query, filter } = findQueryFilter(cohorts, ownProps);
  if (filter) {
    const { filter: filterBeforeEdit } = findQueryFilter(cohorts, ownProps, true);
    return withItem(query.dataset, ownProps.dictionaryCode, filter, role, cohort, filterBeforeEdit);
  }

  return withoutItem(role);
};

export default QueryFilterContainer;
